import React, { useState } from "react";
export const CLOSED_RIGHT_MARGIN = 40;
export const OPEN_RIGHT_MARGIN = 230;
export const MarginContext = React.createContext({
    setLeftMargin: () => { },
    setRightMargin: () => { },
    isLegendOpen: true,
    margins: { top: 0, bottom: 45, left: 40, right: 225 },
    setIsLegendOpen: () => { },
});
export function MarginContextContainer({ initialMargins = { top: 0, bottom: 45, left: 40, right: 225 }, children, }) {
    const [margins, setMargins] = useState(initialMargins);
    const [isLegendOpen, setIsLegendOpen] = useState(true);
    const setRightMargin = (newValue) => setMargins((prev) => (Object.assign(Object.assign({}, prev), { right: newValue })));
    const setLeftMargin = (newValue) => setMargins((prev) => (Object.assign(Object.assign({}, prev), { left: newValue })));
    return (React.createElement(MarginContext.Provider, { value: {
            setLeftMargin,
            setRightMargin,
            margins,
            isLegendOpen,
            setIsLegendOpen,
        } }, children));
}
//# sourceMappingURL=MarginContextContainer.js.map